import React from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CotizadorNIProvider from '../../context/CotizadorNIDataContext';
import MicroSitioAuto from '../pages/MicroSitioAuto';
import CotizadorNI from './CotizadorNI';

const MicrositioAutoNIRoot = () => {

    return (
        <CotizadorNIProvider>
            <Container>
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <Switch>
                        <Route exact path="/micrositio/cotizadorni" component={CotizadorNI} />
                        <Route exact path="/micrositio/automovilni" component={MicroSitioAuto} />
                        
                    </Switch>
                </BrowserRouter>
            </Container>
        </CotizadorNIProvider>


    );
}

export default MicrositioAutoNIRoot;
